/**
 * 参照注册数据
 * @author Paul.Yang E-mail:yaboocn@qq.com
 * @version 1.0 2017-7-24
 */
export default {
  'ref-demo': {
    props: {
      title: '参照演示'
    },
    component: 'ss'
  },
  'ref-model': {
    props: {
      title: '参照演示'
    },
    component: 'ref-model'
  },
  'query-org': {
    props: {
      title: '公司'
    },
    component: 'query-org'
  },
  'query-edu': {
    props: {
      title: '学历'
    },
    component: 'query-edu'
  },
  'query-techpost': {
    props: {
      title: '从事行业'
    },
    component: 'query-techpost'
  },
  'query-postseries': {
    props: {
      title: '岗位序列'
    },
    component: 'query-postseries'
  },
  'query-pol': {
    props: {
      title: '政治面貌'
    },
    component: 'query-pol'
  },
  'query-job': {
    props: {
      title: '职务'
    },
    component: 'query-job'
  },
  'query-tag': {
    props: {
      title: '标签'
    },
    component: 'query-tag'
  },
  'query-marital': {
    props: {
      title: '婚育'
    },
    component: 'query-marital'
  },
  'org-tree': {
    props: {
      title: '公司'
    },
    component: 'org-tree'
  },
  'idtype': {
    props: {
      title: '证件类型'
    },
    component: 'idtype'
  },
  'nativeplace': {
    props: {
      title: '籍贯'
    },
    component: 'nativeplace'
  },
  'characterrpr': {
    props: {
      title: '性质'
    },
    component: 'characterrpr'
  },
  'nationality': {
    props: {
      title: '民族'
    },
    component: 'nationality'
  },
  'polity': {
    props: {
      title: '面貌'
    },
    component: 'polity'
  },
  'health': {
    props: {
      title: '状况 '
    },
    component: 'health'
  },
  'marital': {
    props: {
      title: '婚姻'
    },
    component: 'marital'
  },
  'edu': {
    props: {
      title: '学历 '
    },
    component: 'edu'
  },
  'pk_degree': {
    props: {
      title: '学位'
    },
    component: 'pk_degree'
  },
  'titletechpost': {
    props: {
      title: '专业技术职务'
    },
    component: 'titletechpost'
  },
  'prof': {
    props: {
      title: '职业资格 '
    },
    component: 'prof'
  },
  'addr': {
    props: {
      title: '家庭地址 '
    },
    component: 'addr'
  },
  'penelauth': {
    props: {
      title: '个人身份'
    },
    component: 'penelauth'
  },
  'permanreside': {
    props: {
      title: '户口所在地 '
    },
    component: 'permanreside'
  },
  'country': {
    props: {
      title: '国籍/地区 '
    },
    component: 'country'
  },
  'mem_relation': {
    props: {
      title: '与本人关系 '
    },
    component: 'mem_relation'
  },
  'politics': {
    props: {
      title: '政治面貌 '
    },
    component: 'politics'
  },
  'creator': {
    props: {
      title: '创建人 '
    },
    component: 'creator'
  },
  'modifier': {
    props: {
      title: '修改人 '
    },
    component: 'modifier     '
  },
  'pk_org': {
    props: {
      title: '所属组织 '
    },
    component: 'pk_org'
  },
  'pk_group': {
    props: {
      title: '所属集团'
    },
    component: 'pk_group'
  },
  'majortype': {
    props: {
      title: '学历专业类别 '
    },
    component: 'majortype'
  },
  'studymode': {
    props: {
      title: '学习方式 '
    },
    component: 'studymode'
  },
  'education': {
    props: {
      title: '学历'
    },
    component: 'education'
  },
  'pk_majorcorp': {
    props: {
      title: '合同主题单位'
    },
    component: 'pk_majorcorp'
  },
  'pk_conttext': {
    props: {
      title: '劳动合同模板'
    },
    component: 'pk_conttext'
  },
  'pk_psnorg': {
    props: {
      title: '组织关系主键'
    },
    component: 'pk_psnorg'
  },
  'pk_psnjob': {
    props: {
      title: '任职主键'
    },
    component: 'pk_psnjob'
  },
  'pk_unchreason': {
    props: {
      title: '解除合同原因'
    },
    component: 'pk_unchreason'
  },
  'termtype': {
    props: {
      title: '合同期限类型'
    },
    component: 'termtype'
  },
  'titlerank': {
    props: {
      title: '职称等级'
    },
    component: 'titlerank'
  },
  'pk_techposttitle': {
    props: {
      title: '获得职称'
    },
    component: 'pk_techposttitle'
  },
  'abroadarea': {
    props: {
      title: '获得职称'
    },
    component: 'abroadarea'
  },
  'leader-query-ref': {
    props: {
      title: ''
    },
    component: 'query-ref'
  },
  'leave-type-query': {
    props: {
      title: ''
    },
    component: 'leave-type'
  },
  'away-type-query': {
    props: {
      title: ''
    },
    component: 'away-type'
  },
  'signcard-type-query': {
    props: {
      title: ''
    },
    component: 'signcard-type'
  },
  'switch-type-query': {
    props: {
      title: ''
    },
    component: 'switch-type'
  },
  'switch-shift-query': {
    props: {
      title: ''
    },
    component: 'switch-shift'
  },
  'transtype-query': {
    props: {
      title: '流程类型'
    },
    component: 'transtype'
  },
  'certify-applyer': {
    props: {
      title: '受理人'
    },
    component: 'certify-applyer'
  },
  'user-ref': {
    props: {
      title: '抄送人'
    },
    component: 'user-ref'
  },
  'mutiple-ref': {
    props: {
      title: ''
    },
    component: 'mutiple-ref'
  },
  'deployment-query': {
    props: {
      title: '调配申请查询'
    },
    component: 'deployment-query'
  },
  'quit-business-type': {
    props: {
      title: '离职业务类型'
    },
    component: 'quit-business-type'
  },
  'quit-transtype-type': {
    props: {
      title: '离职流程类型'
    },
    component: 'quit-transtype-type'
  },
  'quit-reason': {
    props: {
      title: '离职原因'
    },
    component: 'quit-reason'
  },
  'quit-select-data': {
    props: {
      title: '离职参照'
    },
    component: 'quit-select-data'
  },
  'regular-select-data': {
    props: {
      title: '转正参照'
    },
    component: 'regular-select-data'
  },
  'regular-business-type': {
    props: {
      title: '试用类型'
    },
    component: 'regular-business-type'
  },
  'regular-transtype-type': {
    props: {
      title: '转正流程类型'
    },
    component: 'regular-transtype-type'
  },
  'on-trial-result': {
    props: {
      title: '试用结果'
    },
    component: 'on-trial-result'
  },
  'regular-tutor-person': {
    props: {
      title: '督导人'
    },
    component: 'regular-tutor-person'
  },
  'fellowworkers-ref': {
    props: {
      title: '同行人员选择'
    },
    component: 'fellowworkers-ref'
  }
}



// WEBPACK FOOTER //
// ./src/data/ref-reg.js